module.exports = __webpack_public_path__ + "img/mig-2.34c62344.png";